/* El Rincón — JS global: agregar al carro vía AJAX, contador y toast */
(function () {
  var toastTimer;

  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('visible'); }, 2600);
  }

  function actualizarContador() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = document.getElementById('contador-carro');
        if (!c) return;
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form.js-atc')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var textoOriginal = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      })
      .then(function () {
        toast('Pieza agregada al carro');
        if (btn) { btn.classList.add('ok'); btn.textContent = 'Agregado ✓'; }
        actualizarContador();
        setTimeout(function () {
          if (btn) { btn.classList.remove('ok'); btn.textContent = textoOriginal; btn.disabled = false; }
        }, 1400);
      })
      .catch(function (err) {
        toast((err && err.description) || 'No se pudo agregar la pieza');
        if (btn) { btn.textContent = textoOriginal; btn.disabled = false; }
      });
  });

  document.addEventListener('DOMContentLoaded', actualizarContador);

  /* Galería de producto: cambiar imagen principal */
  document.addEventListener('click', function (e) {
    var mini = e.target.closest('.producto-miniaturas img');
    if (!mini) return;
    var principal = document.querySelector('.producto-galeria .principal img');
    if (principal) principal.src = mini.dataset.full || mini.src;
  });

  /* Menú móvil: abrir/cerrar */
  function cerrarMenu() {
    var toggle = document.getElementById('nav-toggle');
    var links = document.getElementById('nav-links');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (links) links.classList.remove('abierto');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('#nav-toggle');
    if (toggle) {
      var abierto = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!abierto));
      var links = document.getElementById('nav-links');
      if (links) links.classList.toggle('abierto', !abierto);
      return;
    }
    if (e.target.closest('#nav-links a')) {
      cerrarMenu();
      return;
    }
    if (!e.target.closest('.nav')) {
      cerrarMenu();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarMenu();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 860) cerrarMenu();
  });
})();
